<template>
  <div>
    <b-row>
      <!----- SideBar All Design List ---->
      <!-- <sidebarSettingsComponent></sidebarSettingsComponent> -->
      <div class="userdetailside">
        <sidebarForOrdersheet></sidebarForOrdersheet>
      </div>
      <!----- SideBar All Design List End ---->

      <div id="overlaymcclist" >
        <div class="loadermcclist"></div>
        <br/>
        Loading...
      </div>

      
      <div class="design-container-details__main" style="width:75%;">
        <div class="col-md-12 ">
          <!-- code for table -->
          <b-row>
            <div class="col-md-12">
              <b-col md="12">
                <b-card-body>
                  <div class="row mt-4">
                    <div class="col-md-10 pull-left">
                      <h3>MCC Report Details</h3>
                    </div>
                   <div style="border:1px solid #C8CED3; padding:10px;">
                    <!-- <h5>Report Request Form</h5> -->
                      <b-row>
                        <!-- <b-col md="6">
                          <b-row>
                            <b-col md="5">
                              <br>
                              <h5> Select Brand : </h5>
                            </b-col>
                            <b-col>
                              <br>
                              <b-input-group class="mb-3">
                            
                                <ejs-multiselect
                                  id="multiselect"
                                  placeholder="Select brand"
                                  v-model="selected_brandid"
                                  name="sel_subcat"
                                  :dataSource="brand_itemvalue"
                                  :showSelectAll="showSelectAll"
                                  selectAllText="Select All"
                                  unSelectAllText="unSelect All"
                                  :fields="brandfields"
                                >
                                </ejs-multiselect>
                              </b-input-group>
                            </b-col>
                          </b-row>
                      
                        </b-col>
                        <b-col md="6">
                          <h5>
                          <b-form-checkbox
                            id="checkbox-1"
                            v-model="includeImages"
                          >
                            Include Images
                          </b-form-checkbox>
                          <br>
                        </h5>
                        </b-col> -->

                        <b-col md="4" class="pull-left" v-if="user_type == 'Planner_Admin' || user_type == 'Planner'">
                          <h5>Select Category:-</h5>
                          <form>
                            <div
                              v-for="categoryList in category_name_arr"
                              :key="categoryList.category_id"
                            >
                              <input
                                @click="showDownloadButtion(categoryList.category_id),getselecteduserbrand(categoryList.category_id) "
                                name="categoryList"
                                id="categoryList.category_id"
                                type="radio"
                                :value="categoryList.category_id"
                              />&nbsp;{{ categoryList.category_title }}
                            </div>
                            <p v-if="this.category_name_arr.length == 0">NA</p>
                          </form>
                        </b-col>
                        <b-col md="4" v-if="user_type == 'Planner_Admin' || user_type == 'Planner'">
                          <b-input-group class="mt-2">
                            
                            <ejs-multiselect
                              id="sub_catid"
                              placeholder="Select Sub-Category"
                              v-model="sub_catid"
                              name="sub_catid"
                              :fields="subcatid_fields"
                              :dataSource="sub_cat_id_arr"
                              :showSelectAll="true"
                              :class="{ input: true }"
                              @change="getSubCatToShowPoType()"
                            >
                            </ejs-multiselect>
                          </b-input-group>
                        </b-col>
                        <b-col md="4" v-if="user_type == 'Planner_Admin' || user_type == 'Planner'">
                          <!-- {{ po_typearr }} -->
                          <b-input-group class="mt-2">
                            
                            <ejs-multiselect
                              id="selected_po_id"
                              placeholder="Select PO Id"
                              v-model="selected_po_id"
                              name="selected_po_id"
                              :fields="poid_fields"
                              :dataSource="po_typearr"
                              :showSelectAll="true"
                              :class="{ input: true }"
                            >
                            </ejs-multiselect>
                          </b-input-group>
                        </b-col>
                        <!-- {{ brand_itemvalue }} -->
                        <b-col md="4">
                           <b-input-group class="mb-3">
                               
                                <ejs-multiselect
                                  id="multiselect"
                                  placeholder="Select brand"
                                  v-model="selected_brandid"
                                  name="sel_subcat"
                                  :dataSource="brand_itemvalue"
                                  :showSelectAll="showSelectAll"
                                  selectAllText="Select All"
                                  unSelectAllText="unSelect All"
                                  :fields="brandfields"
                                   @change="callVendorList(selected_brandid)"
                                >
                                </ejs-multiselect>
                              </b-input-group>
                        </b-col>

                        <b-col md="4" class="" v-if="user_type == 'Planner_Admin' || user_type == 'Planner'">
                          <b-input-group class="mb-3">
                            <ejs-multiselect
                              id="brandtype"
                              placeholder="Select brandtype"
                              v-model="brandtype"
                              name="brandtype"
                              :fields="brandtypeid"
                              :dataSource="brandTypeName"
                              :showSelectAll="true"
                              :class="{ input: true }"
                            >
                            </ejs-multiselect>
                          </b-input-group>
                          <!-- <select class="form-control" v-if="this.selectedCatId==''" disabled="true"><option>choose option</option></select> -->
                        </b-col>


                        
                        <b-col md="4" >
                          <b-input-group class="mb-3">
                            <ejs-multiselect
                              id="vendornameseach"
                              placeholder="Select Vendor Name"
                              v-model="vendornameseach"
                              name="vendornameseach"
                              :fields="vendorid"
                              :dataSource="vendorName"
                              :showSelectAll="true"
                              :class="{ input: true }"
                            >
                            </ejs-multiselect>
                          </b-input-group>
                      </b-col>

                   
                      

                    <b-col md="4" v-if="user_type =='Admin' || user_type == 'Planner_Admin' || user_type == 'Planner'">

                          <b-input-group class="mb-3">          
                            <ejs-multiselect @change="showCollection"
                              id="segmentId"
                              placeholder="Select Segment"
                              v-model="segmentId"
                              name="segmentId"
                              :fields="segementid_fields"
                              :dataSource="segmentarray_list"
                              :showSelectAll="true"
                              :class="{ input: true }"
                            >
                            </ejs-multiselect>
                          </b-input-group>

                          </b-col>

                          <b-col md="4" v-if="user_type !='Admin' && user_type != 'Planner_Admin' && user_type != 'Planner'">
                              <b-input-group class="mb-3">
                                <ejs-multiselect @change="showCollection"
                                  id="segmentId"
                                  placeholder="Select segment Type"
                                  v-model="segmentId"
                                  name="segmentId"
                                  :fields="segment"
                                  :dataSource="segmentarray_list"
                                  :showSelectAll="true"
                                  :class="{ input: true }"
                                >
                                </ejs-multiselect>
                              </b-input-group>
                            
                          </b-col>

                          <b-col md="4" v-if="user_type =='Admin' || user_type == 'Planner_Admin' || user_type == 'Planner'">
                            <b-input-group>
                                          
                              <ejs-multiselect
                                id="collectionid"
                                placeholder="Select Season"
                                v-model="collectionid"
                                name="collectionid"
                                :fields="collectionid_fields"
                                :dataSource="collectionData"
                                :showSelectAll="true"
                                :class="{ input: true }"
                              >
                              </ejs-multiselect>
                            </b-input-group>

                          </b-col>

                          <b-col md="4" v-if="user_type == 'Planner_Admin' || user_type == 'Planner'">
                            <b-input-group class="">
                              <!-- {{ sleeveLength_arr }} -->
                              <ejs-multiselect
                                id="sleeveLength"
                                placeholder="Select Sleeve-Length"
                                v-model="sleeveLength"
                                name="sleeveLength"
                                :fields="sleeve_fields"
                                :dataSource="sleeveLength_arr"
                                :showSelectAll="true"
                                :class="{ input: true }"
                              >
                              </ejs-multiselect>
                            </b-input-group>
                         </b-col>

                          <b-col md="4" class="" v-if="user_type !='Admin' && user_type != 'Planner_Admin' && user_type != 'Planner'">
                              <b-input-group class="mb-3">
                                <ejs-multiselect
                                  id="collectionid"
                                  placeholder="Select Season Type"
                                  v-model="collectionid"
                                  name="collectionid"
                                  :fields="collection"
                                  :dataSource="collectionData"
                                  :showSelectAll="true"
                                  :class="{ input: true }"
                                >
                                </ejs-multiselect>
                              </b-input-group>
                              <!-- <select class="form-control" v-if="this.selectedCatId==''" disabled="true"><option>choose option</option></select> -->
                          </b-col>

                          <!-- <b-col md="4" class="" v-if="user_type == 'Planner_Admin' && user_type == 'Planner'"> -->
                            <!-- <b-input-group class="mb-3">
                              <ejs-multiselect
                                id="category"
                                placeholder="Select Category"
                                v-model="category"
                                name="category"
                                :fields="category"
                                :dataSource="collectionData"
                                :showSelectAll="true"
                                :class="{ input: true }"
                              >
                              </ejs-multiselect>
                            </b-input-group> -->
                            <!-- <select class="form-control" v-if="this.selectedCatId==''" disabled="true"><option>choose option</option></select> -->
                        <!-- </b-col> -->


                        <!-- <b-col md="4" class="" v-if="user_type == 'Planner_Admin' && user_type == 'Planner'"> -->
                          <!-- <b-input-group class="mb-3">
                            <ejs-multiselect
                              id="SubCategory"
                              placeholder="Select SubCategory"
                              v-model="subcategory"
                              name="subcategory"
                              :fields="subcategory"
                              :dataSource="collectionData"
                              :showSelectAll="true"
                              :class="{ input: true }"
                            >
                            </ejs-multiselect>
                          </b-input-group> -->
                          <!-- <select class="form-control" v-if="this.selectedCatId==''" disabled="true"><option>choose option</option></select> -->
                      <!-- </b-col> -->

                      <!-- <b-col md="4" class="" v-if="user_type == 'Planner_Admin' && user_type == 'Planner'"> -->
                        <!-- <b-input-group class="mb-3">
                          <ejs-multiselect
                            id="potype"
                            placeholder="Select potype"
                            v-model="potype"
                            name="potype"
                            :fields="potype"
                            :dataSource="collectionData"
                            :showSelectAll="true"
                            :class="{ input: true }"
                          >
                          </ejs-multiselect>
                        </b-input-group> -->
                        <!-- <select class="form-control" v-if="this.selectedCatId==''" disabled="true"><option>choose option</option></select> -->
                    <!-- </b-col> -->

                

                       <b-col md="4" class="mt-2">
                          <h6>
                          <b-form-checkbox
                            id="checkbox-1"
                            v-model="includeImages"
                            :disabled="!isAnyFilterSelected"
                          >
                            Include Images
                          </b-form-checkbox>
                          <br>
                        </h6>
                        </b-col>
                        <!-- <b-col md="4">
                          <datepicker
                          placeholder="Select From Date"
                          slot="beforeCalendarHeader"
                          class="calender-header"
                          v-model="selectedfrom_date"
                          id="enddate"
                          :format="DatePickerFormat"
                          required
                        >
                          Inspection From Date
                        </datepicker>
                        </b-col>
                        <b-col md="4">
                          <datepicker
                          placeholder="Select To Date"
                          slot="beforeCalendarHeader"
                          class="calender-header"
                          v-model="selectedto_date"
                          id="enddate"
                          :format="DatePickerFormat"
                          required
                        >
                          Inspection To Date
                        </datepicker>
                        </b-col> -->
                        <b-col>
                          <div class="float-right mr-3">
                            <button
                              type="button"
                              class="btn btn-success"
                              @click="getorderlistcsv()"
                            >
                              Download
                            </button>
                          </div>
                        </b-col>
                      </b-row>
                   </div>

                  </div>

                  <!-- <b-col md="12">
                    <div class="">
                    </div>

                    <b-table
                      class="mt-4"
                      caption-top
                      show-empty
                      stacked="md"
                      :busy="isBusy"
                      :items="items2"
                      :fields="fields3"
                      :current-page="currentPage"
                      :perPage="perPage"
                      :bordered="true"
                      :filter="filter"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :sort-direction="sortDirection"
                      @filtered="onFiltered"
                    >
                      <div
                        slot="table-busy"
                        class="text-center text-danger my-2"
                      >
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>

                      <template slot="seasontab" slot-scope="row">
                        <p
                          v-if="
                            row.item.season == null || row.item.season == ''
                          "
                        >
                          NA
                        </p>
                        <p
                          v-if="
                            row.item.season != '' || row.item.season != null
                          "
                        >
                          {{ row.item.season }}
                        </p>
                      </template>
                    </b-table>
                  </b-col> -->
                </b-card-body>
              </b-col>
            </div>
          </b-row>
          <!-- code for table ends -->
         
          <!-- <div class="col-md-12 mb-5">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              class="my-0"
            ></b-pagination>
          </div> -->
          <!-- </b-col>  -->

          <!-- Code For ordersheet Details Model -->
          <b-modal
            id="modal-xl_ordersheet"
            size="lg"
            title="Order Sheet Details"
            v-model="showdownloadsheetdeatils"
            @ok="showdownloadsheetdeatils = false"
          >
            <b-row>
              <b-row class="detailsrow">

                <b-col cols="12" class="coldesign ml-5">
                  <div class="col-md-12 stylefield">
                    <b-form-group>
                      <b-col md="5" class="pull-left">
                        <label for="name"><b>Style Name</b></label>
                      </b-col>
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                      <b-col md="6" class="pull-right titleb">
                        {{ style_name }}
                      </b-col>
                    </b-form-group>
                  </div>

                  <div class="col-md-12 stylefield">
                    <b-form-group>
                      <b-col md="5" class="pull-left">
                        <label for="name"><b>Style Code</b></label>
                      </b-col>
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                      <b-col md="6" class="pull-right titleb">
                        {{ style_code }}
                      </b-col>
                    </b-form-group>
                  </div>

                  <div class="col-md-12 stylefield">
                    <b-form-group>
                      <b-col md="5" class="pull-left">
                        <label for="name"><b>color</b></label>
                      </b-col>
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                      <b-col
                        md="6"
                        class="pull-right titleb"
                        v-if="this.color == '' || this.color == null"
                      >
                        <p>NA</p>
                      </b-col>

                      <b-col md="6" class="pull-right titleb">
                        {{ color }}
                      </b-col>
                    </b-form-group>
                  </div>

                  <div class="col-md-12 stylefield">
                    <b-form-group>
                      <b-col md="5" class="pull-left">
                        <label for="name"><b>Sleeve Length</b></label>
                      </b-col>
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                      <b-col
                        md="6"
                        class="pull-right titleb"
                        v-if="
                          this.sleeve_length == '' || this.sleeve_length == null
                        "
                      >
                        <p>NA</p>
                      </b-col>

                      <b-col md="6" class="pull-right titleb">
                        {{ sleeve_length }}
                      </b-col>
                    </b-form-group>
                  </div>

                  <div class="col-md-12 stylefield">
                    <b-form-group>
                      <b-col md="5" class="pull-left">
                        <label for="name"><b>Fabric Type</b></label>
                      </b-col>
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                      <b-col
                        md="6"
                        class="pull-right titleb"
                        v-if="
                          this.fabric_type == '' || this.fabric_type == null
                        "
                      >
                        <p>NA</p>
                      </b-col>

                      <b-col md="6" class="pull-right titleb">
                        {{ fabric_type }}
                      </b-col>
                    </b-form-group>
                  </div>

                  <div class="col-md-12 stylefield">
                    <b-form-group>
                      <b-col md="5" class="pull-left">
                        <label for="name"><b>material</b></label>
                      </b-col>
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                      <b-col
                        md="6"
                        class="pull-right titleb"
                        v-if="this.material == '' || this.material == null"
                      >
                        <p>NA</p>
                      </b-col>
                      <b-col md="6" class="pull-right titleb">
                        {{ material }}
                      </b-col>
                    </b-form-group>
                  </div>

                  <div class="col-md-12 stylefield">
                    <b-form-group>
                      <b-col md="5" class="pull-left">
                        <label for="name"><b>Fabric Content</b></label>
                      </b-col>
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                      <b-col
                        md="6"
                        class="pull-right titleb"
                        v-if="
                          this.fab_content == '' || this.fab_content == null
                        "
                      >
                        <p>NA</p>
                      </b-col>

                      <b-col md="6" class="pull-right titleb">
                        {{ fab_content }}
                      </b-col>
                    </b-form-group>
                  </div>

                  <div class="col-md-12 stylefield">
                    <b-form-group>
                      <b-col md="5" class="pull-left">
                        <label for="name"><b>Total Quantity</b></label>
                      </b-col>
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                      <b-col
                        md="6"
                        class="pull-right titleb"
                        v-if="
                          this.total_quantity == '' ||
                            this.total_quantity == null
                        "
                      >
                        <p>NA</p>
                      </b-col>

                      <b-col md="6" class="pull-right titleb">
                        {{ total_quantity }}
                      </b-col>
                    </b-form-group>
                  </div>

                  <div class="col-md-12 stylefield">
                    <b-form-group>
                      <b-col md="5" class="pull-left">
                        <label for="name"><b>Quote Approved Date</b></label>
                      </b-col>
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                      <b-col
                        md="6"
                        class="pull-right titleb"
                        v-if="
                          this.quote_approved == '' ||
                            this.total_quantity == null
                        "
                      >
                        <p>NA</p>
                      </b-col>

                      <b-col md="6" class="pull-right titleb">
                        {{ quote_approved }}
                      </b-col>
                    </b-form-group>
                  </div>

                  <div class="col-md-12 stylefield">
                    <b-form-group>
                      <b-col md="5" class="pull-left">
                        <label for="name"><b>Exp Date</b></label>
                      </b-col>
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                      <b-col
                        md="6"
                        class="pull-right titleb"
                        v-if="this.exp_date == '' || this.exp_date == null"
                      >
                        <p>NA</p>
                      </b-col>

                      <b-col md="6" class="pull-right titleb">
                        {{ exp_date }}
                      </b-col>
                    </b-form-group>
                  </div>

                  <div class="col-md-12 stylefield">
                    <b-form-group>
                      <b-col md="5" class="pull-left">
                        <label for="name"><b>Season Code</b></label>
                      </b-col>
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                      <b-col
                        md="6"
                        class="pull-right titleb"
                        v-if="
                          this.season_code == '' || this.season_code == null
                        "
                      >
                        <p>NA</p>
                      </b-col>

                      <b-col md="6" class="pull-right titleb">
                        {{ season_code }}
                      </b-col>
                    </b-form-group>
                  </div>

                  <div class="col-md-12 stylefield">
                    <b-form-group>
                      <b-col md="5" class="pull-left">
                        <label for="name"><b>Sub Category Title</b></label>
                      </b-col>
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                      <b-col
                        md="6"
                        class="pull-right titleb"
                        v-if="
                          this.sub_cat_title == '' || this.sub_cat_title == null
                        "
                      >
                        <p>NA</p>
                      </b-col>

                      <b-col md="6" class="pull-right titleb">
                        {{ sub_cat_title }}
                      </b-col>
                    </b-form-group>
                  </div>

                  <div class="col-md-12 stylefield">
                    <b-form-group>
                      <b-col md="5" class="pull-left">
                        <label for="name"><b>Gender</b></label>
                      </b-col>
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                      <b-col
                        md="6"
                        class="pull-right titleb"
                        v-if="this.gender == '' || this.gender == null"
                      >
                        <p>NA</p>
                      </b-col>

                      <b-col md="6" class="pull-right titleb">
                        {{ gender }}
                      </b-col>
                    </b-form-group>
                  </div>

                  <div class="col-md-12 stylefield">
                    <b-form-group>
                      <b-col md="5" class="pull-left">
                        <label for="name"><b>PO Type</b></label>
                      </b-col>
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                      <b-col
                        md="6"
                        class="pull-right titleb"
                        v-if="this.po_type == '' || this.po_type == null"
                      >
                        <p>NA</p>
                      </b-col>

                      <b-col md="6" class="pull-right titleb">
                        {{ po_type }}
                      </b-col>
                    </b-form-group>
                  </div>

                  <div class="col-md-12 stylefield">
                    <b-form-group>
                      <b-col md="5" class="pull-left">
                        <label for="name"><b>Utility </b></label>
                      </b-col>
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                      <b-col
                        md="6"
                        class="pull-right titleb"
                        v-if="this.utility == '' || this.utility == null"
                      >
                        <p>NA</p>
                      </b-col>

                      <b-col md="6" class="pull-right titleb">
                        {{ utility }}
                      </b-col>
                    </b-form-group>
                  </div>

                  <div class="col-md-12 stylefield">
                    <b-form-group>
                      <b-col md="5" class="pull-left">
                        <label for="name"><b>Vendor Name</b></label>
                      </b-col>
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                      <b-col
                        md="6"
                        class="pull-right titleb"
                        v-if="
                          this.vendor_name == '' || this.vendor_name == null
                        "
                      >
                        <p>NA</p>
                      </b-col>

                      <b-col md="6" class="pull-right titleb">
                        {{ vendor_name }}
                      </b-col>
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>

              <div
                slot="footer"
                class="col-md-12"
                style="margin-top:20px;text-align:right"
              >
                <b-button
                  size="sm"
                  variant="danger"
                  @click="downloadsheetdeatilscancel()"
                  >cancel</b-button
                >
              </div>
            </b-row>
          </b-modal>

          <h5>Download Requests Log</h5>
          <b-table show-empty
          responsive
          :busy="isBusylist"
          :items="report_requestlist"
          :fields="fieldslist"
          :current-page="currentPagelist"
          :perPage="perPagelist"
          :bordered="true"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="onFiltered"
          title="Download Requests Log"
        >
          <div
            slot="table-busy"
            class="text-center text-danger my-2"
          >
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>

          <template slot="filters" slot-scope="row">
            <!-- {{ row.item.filters }} -->
            <strong>Brand Name :-</strong>
            <span>{{ JSON.parse(row.item.filters).assigned_brand_name }}</span><br>
            <strong>Include Images :-</strong> <span v-if="JSON.parse(row.item.filters).includeImages==true">YES</span>
            <span v-if="JSON.parse(row.item.filters).includeImages==false">NO</span><br>
            <!-- <strong>From Date :-</strong> <span>{{ JSON.parse(row.item.filters).from_date==""? 'NA' : JSON.parse(row.item.filters).from_date}}</span><br>
            <strong>To Date :-</strong> <span>{{ JSON.parse(row.item.filters).to_date==""? 'NA' : JSON.parse(row.item.filters).to_date}}</span><br> -->
            
          </template>

          <template slot="file_url" slot-scope="row">
            <a :href="row.item.file_url" download v-if="row.item.is_complete==true && row.item.file_url != null ">
              <i class="fa fa-download" aria-hidden="true"></i>
            </a>
          </template>

          <template slot="is_complete" slot-scope="row">
            <span v-if="row.item.is_complete==true && row.item.file_url != null">
              Completed
            </span>
            <span v-if="row.item.is_complete==true &&  row.item.file_url == null">
              No record to download
            </span>
            <span v-if="row.item.is_complete==false">
              Pending
            </span>
          </template>
        </b-table>
        <br>
        <b-pagination
        v-model="currentPagelist"
        :total-rows="totalrecordlist"
        :per-page="perPagelist"
        class="my-0"
      ></b-pagination>
      <br><br>
        </div>
      </div>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import auth from '@/utils/auth'
import Vue from 'vue'
import Utils from "@/utils";

import sidebarForOrdersheet from './_sidebarForOrdersheet.vue'
import Datepicker from "vuejs-datepicker";

const axios = require('axios')
export default {
  name: 'Ordersheet',

  components: {
    sidebarForOrdersheet,
    Datepicker
  },
  data() {

    return {
      isBusy: false,
      design_file_list: [],
      catselected: '',
      subcatselected: '',
      cat_title: '',
      sub_cat_title: '',
      created_date: '',
      title: '',
      id: 0,
      design_no: '',
      no: 0,
      showdownloadsheetdeatils: false,
      style_image: '',
      style_code:'',
      color: '',
      sleeve_length: '',
      fabric_type: '',
      material: '',
      fab_content: '',
      total_quantity: '',
      quote_approved: '',
      exp_date: '',
      season_code: '',
      sub_cat_title: '',
      gender: '',
      po_type: '',
      utility: '',
      vendor_name: '',
      openimagemodel: false,
      // items2:[],


      col_id: 0,
      imgpath: '',
      totalRows: 0,
      visible: true,
      list: [],
      user_id: 0,
      messagedata: [],
      selectedId: 0,
      txtInput: '',
      selected: '',
      customer: {},
      user_result: [],
      currentPage: 1,
      perPage: 10,



      selectedDate: new Date(),
      items: [],
      result: [],
      img_result: [],
      userdetails: [],
      user_id: '',
      assigned_sub_cat_id: [],
      design_details: [],
      changepassword: false,
      changeprofile: false,
      uploadphoto: false,
      file: '',
      arr: [],
      img_path: '',
      avatar: null,
      image: '',
      items: [1],
      activeTab: 1,
      selectedFile: null,
      remoteUrl: '',
      image1: {},
      isToggled: false,
      selected_brand_id: 0,
      dh_status: false,
      dh_avaliable_status: 0,
      user_type: '',

      //progressBar
      selectedFiles: '',
      currentFile: '',
      progress: 0,
      message: "",
      fields: [
        { key: 'style_name', label: 'Style Name' },
        { key: 'style_code', label: 'Style Code' },

        { key: 'color', label: 'Color' },
        { key: 'season', label: 'Season' },
        { key: 'total_quantity', label: 'Total Quantity' },
        { key: 'po_type', label: 'PO Type' },
        { key: 'status', label: 'Status' },
        // {key: ''}
        // {key: 'actions', label:'Actions'}

      ],

      fields3: [

        // { key: 'style_code', label: 'Style Code' },
        { key: 'style_number', label: 'Style Number' },
        { key: 'brand', label: 'Brand Name' },
        { key: 'subcat', label: 'Sub-category Name' },
        { key: 'buyer', label: 'Buyer Name' },
          { key: 'color', label: 'Color' },
          { key: 'core_fashion', label: 'Core Fashion' },
          { key: 'gender', label: 'Gender' },
          { key: 'product_type', label: 'Product Type' },
          { key: 'quantity', label: 'quantity' },
          { key: 'seasontab', label: 'Season'},


            ],
        includeImages : false,
      selectedfrom_date : '',
      selectedto_date: '',
      report_requestlist :[],
      totalrecordlist : 0,
      isBusylist: false,
      currentPagelist: 1,
      perPagelist: 5,
      fieldslist : [
        {key:'request_id', label: 'Request ID'},
        {key :'filters', label: 'Filters', tdClass:'widthclass'},
        {key : 'requested_date', label: 'Request Date'},
        {key : 'file_url', label: 'File URL'},
        {key : 'is_complete', label: 'IS Complete'},
        {key : 'completed_date', label: 'Completed Date'},
      ],
      filerrequestlist  : [],
      brand_item : [],
      brand_itemvalue :[],
      brandfields : { text: 'name', value: 'id' },
      selected_brandid :[],
      showSelectAll: true,
      selectbrand_name :[],
      selectbrand_id :[],
      segmentarray_list:[],
      segmentId:[],
      segment : { text: "text", value: "value" },
      segment_panner : { text: "seg_name", value: "segment_id" },
      vendorid: { text: "text", value: "value" },
      vendorName:[],
      vendornameseach:[],
      collection: { text: "text", value: "value" },
      collectionData:[],
      uniqueData:[],
      collectionid:[],
      tempVendorlist :[],
      isMultipleVndorSelected: false,
      segmentarray_list1:[],
      tempbrandid:[],
      segementid_fields: { text: "text", value: "value" },
      collectionid_fields:  { text: "text", value: "value" },
      potype:'',
      subcategory:'',
      category:'',
      brandtypeid: { text: "text", value: "value" },
      brandTypeName:[],
      categorytypeid: { text: "text", value: "value" },
      categoryTypeName:'',
      category_name_arr: [],
      selectedCatId:'',
      sub_cat_id_arr:[],
      selected_po_id:null,
      po_typearr:[],
      sub_catid: null,
      poid_fields:  { text: "text", value: "value" },
      sleeveLength_arr:[],
      subcatid_fields: { text: "text", value: "value" },
      sleeve_fields: { text: "text", value: "value" },
    }
  },
  computed: {
    isAnyFilterSelected() {
      return (
        (this.selected_brandid && this.selected_brandid.length > 0) ||
        (this.segmentId && this.segmentId.length > 0) ||
        (this.collectionid && this.collectionid.length > 0) ||
        (this.vendornameseach && this.vendornameseach.length > 0) ||
        this.selectedCatId !== '' ||
        (this.sub_catid && this.sub_catid.length > 0) ||
        (this.selected_po_id && this.selected_po_id.length > 0) ||
        (this.brandtype && this.brandtype.length > 0) ||
        (this.sleeveLength && this.sleeveLength.length > 0)
      )
    }
  },
  watch: {
    isAnyFilterSelected(newVal) {
      // Reset includeImages when no filters are selected
      if (!newVal) {
        this.includeImages = false;
      }
    }
  },
  created: function () {
   
    this.id = this.$route.params.id;
    this.no = this.$route.params.no;
    this.col_id = this.$route.params.col_id;
    var userData = localStorage.getItem('userData');
    var userInfo = JSON.parse(userData);
    this.user_type = userInfo[0].user_type;
    this.user_id = userInfo[0].user_id;
    console.log('this.user_type', this.user_type);

    if(this.user_type == 'Admin')
      {
          this.getBrandSegmentListForAdmin(this.tempbrandid)
         
      }
    else if(this.user_type == 'Planner_Admin' || this.user_type == 'Planner'){
      this.getBrandSegmentListForAdmin(this.tempbrandid)
          this.getcategorylistingbybuyer();
          this.getBrandType()
          this.showSubcategory( this.selectedCatId,userInfo[0].user_id)
          this.getPoTypeList(this.sub_catid,userInfo[0].user_id)
          this.getSleevelength()
    }
    else{
      this.getBrandSegmentList();
    }
    this.getusersdetails();
    // this.getmcclistdata();
    this.ReportListing();
    this.getselecteduserbrand();
    this.showCollection();
    this.displayvendorlist();
  },
  mounted: function() {
    this.ReportListing();
    //  this.getselecteduserbrand();
    // this.getmcclistdata();
  },
  methods: {

    //function to get users details
    getusersdetails: function () {
      // alert("In")
      // document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData)
      this.access_token = userInfo[0]['token']
      axios.defaults.headers.common['x-access-token'] = this.access_token;
      axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
      axios.defaults.headers.common['Accept'] = 'application/json';
      axios.defaults.headers.common['Origin'] = 'http://localhost:8080';

      const Obj = {
        user_id: userInfo[0].user_id
      }
      axios.post(`${CONSTANTS.API_URL}/getloginuserdetails`, Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data
          // console.log("LLLLLLLLLLLLLLL", this.result)
          if (this.result.returnmsg === 'Successful') {
            // console.log("LLLLLLLLLLLLLLL", this.result.returnvalue)
            this.user_result = this.result.returnvalue;
            this.assigned_sub_cat_id = this.user_result[0].subcat_assign;
            this.selected_brand_id = this.user_result[0].brand_assign;
            this.remoteUrl = this.user_result[0].profile_image;
            this.customer = {};
            this.dh_avaliable_status = this.user_result[0].is_dh_available;
            if (this.dh_avaliable_status == 0) {
              this.dh_status = true;
            }
            else {
              this.dh_status = false;
            }
            // this.getdesignsummary(this.id);

          } else {
            this.user_result = [];
            this.totalRows = 0;
            // this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
          document.getElementById("overlay").style.display = "none";
        })

    },


    // getmcclistdata: function ()
    // {
    //   console.log("running mcc list.................")
    //   document.getElementById("overlaymcclist").style.display = "block";
    //   const Obj = {}
    //   axios.post(`${CONSTANTS.API_URL}/getmccreportlisting`, Obj)
    //   .then(response => {
    //     this.result = response.data
    //     if (this.result.returnmsg === 'Successful') {
    //       this.items2 = this.result.returnvalue;
    //       this.totalRows = this.result.returnvalue.length;
    //       document.getElementById("overlaymcclist").style.display = "none";
    //     }
    //     else
    //     {
    //       this.items2 = [];
    //       this.totalRows=0;
    //       document.getElementById("overlaymcclist").style.display = "none";
    //     }
    //   })
    //   .catch(err=>{
    //     console.log(err)
    //     document.getElementById("overlaymcclist").style.display = "none";
    //   })

    // },

    getrowdata: function (value)
    {
      // alert(value);
      // console.log(this.items2);

      this.style_code = value.style_code;
      this.style_image = value.style_image;
      this.style_name = value.style_name;
      this.color = value.color;
      this.sleeve_length = value.sleeve_length;
      this.fabric_type = value.fabric_type;
      this.material = value.material;
      this.fab_content = value.fab_content;
      this.total_quantity = value.total_quantity;
      this.quote_approved = value.quote_approved;
      this.exp_date = value.exp_date;
      this.season_code = value.season_code;
      this.sub_cat_title = value.sub_cat_title;
      this.gender = value.gender;
      this.po_type = value.po_type;
      this.utility = value.utility;
      this.vendor_name = value.vendor_name;
      console.log(this.style_code);

      this.showdownloadsheetdeatils = !this.showdownloadsheetdeatils;

    },

    // getorderlistcsv: async function ()
    // {
    //   document.getElementById("overlaymcclist").style.display = "block";

    //   const Obj = {}
    //   // axios.post(`${CONSTANTS.API_URL}/getmccreportexcel`, Obj)
    //   // .then(response => {
    //   //   console.log(response);
    //   //   this.downloadHelper(response.data);
    //   //   document.getElementById("overlaymcclist").style.display = "none";
    //   // })
    //   // .catch(err=>{
    //   //   console.log(err)
    //   //   document.getElementById("overlaymcclist").style.display = "none";
    //   // })
    //   await axios.post(`${CONSTANTS.API_URL}/getmccreportexcel`,Obj,{responseType: "blob"})
    //   .then(response=>{
    //     console.log(response)
    //     var blob = new Blob([response.data], {type: response.headers["content-type"],});
    //     const link = document.createElement("a");
    //     link.href = window.URL.createObjectURL(blob);
    //     link.download = `mcc_report_${new Date().getTime()}.xlsx`;
    //     link.click();
    //     document.getElementById("overlaymcclist").style.display = "none";
    //   })
    //   .catch(error=>{
    //     console.log(error)
    //     document.getElementById("overlaymcclist").style.display = "none";
    //     this.$fire({
    //     text:"Error In Donwloading Excel!",
    //     type: "warning",
    //     timer: 30000
    //     })
    //   })
    // },


    getorderlistcsv:function(){
        document.getElementById("overlay").style.display = "block";
        if(this.selected_brandid.length == 0 && this.segmentId.length == 0 && this.collectionid.length == 0 && this.vendornameseach.length ==0 
        && this.selectedCatId == ''
        && this.sub_catid == 0
        && this.selected_po_id == 0
        && this.brandtype == 0
        && this.sleeveLength == 0
        ){
        this.$fire({
          text:"Please select atleast one value to download report",
          type: "warning",
          timer: 30000
        }); 
        document.getElementById("overlay").style.display = "none";
        return 
      }
        var userData = localStorage.getItem('userData');
    var userInfo = JSON.parse(userData);
    // console.log("@@@@@@@@@@@@@@@@",userInfo)
    // this.access_token = userInfo[0]['token']
      axios.defaults.headers.common['x-access-token'] = userInfo[0]['token'];
      axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
      axios.defaults.headers.common['Accept'] = 'application/json';
      axios.defaults.headers.common['Origin'] = 'http://localhost:8080';

      console.log("00000000000000000000000000000000000",this.selected_brandid,this.selected_brandid.length)

      // var selectbrand_name = [];
      for (let i = 0; i < this.selected_brandid.length; i++) {
        var brand_name = this.selected_brandid[i].split('-')[0];
        this.selectbrand_name.push(brand_name)
      }
      console.log("ppppppppppppp",this.selectbrand_name.join())

      for (let i = 0; i < this.selected_brandid.length; i++) {
        var brand_id = this.selected_brandid[i].split('-')[1];
        this.selectbrand_id.push(brand_id)
      }
      console.log("ppppppppppppp",this.selectbrand_id.join())



        // var fromdate = (this.selectedfrom_date!='')?this.formatDate(this.selectedfrom_date):"";
        // var formatdateto=(this.selectedto_date!='')? this.formatDate(this.selectedto_date):"";
          var csvObj = {
            assigned_brand_id: `${this.selectbrand_id.join()}`,
            assigned_brand_name : `${this.selectbrand_name.join()}`,
            
            requested_by : userInfo[0].user_id,
            request_type :"mcc",
            includeImages : this.includeImages,
            segment : this.segmentId,
            season :  this.collectionid,
            vendor_name : this.vendornameseach,
            user_id: userInfo[0].user_id,
            cat_id : this.selectedCatId,
            sub_category_id: this.sub_catid,
            po_id: this.selected_po_id,
            new_brand_type: this.brandtype,
            sleeve_length: this.sleeveLength,
           };
            console.log("JJJJJ",csvObj);
          //  return false;
        // if(formatdateto< fromdate){  
        //    this.$fire({
        //           text:"To date need to be greater than From date",
        //           type: "warning",
        //           timer: 30000
        //         }); 
        //     document.getElementById("overlay").style.display = "none";
        //         // this.isBusy = false; 
        //         return false;       
        // }

        
        axios.post(`${CONSTANTS.API_URL}/requestReport`, csvObj)
          .then(result => {
            console.log("$$$$$$$$$$$$$$$$$$$$$$$$$",result)
          document.getElementById("overlay").style.display = "none";
           if(result.data.returnmsg=="successful")
         {
        //  alert("Please Check Ur Mail For Downlod Link")
        this.$fire({
                  title:"Request Successful!",
                  text: "Please wait for 20-30 minutes while your request is in process.",
                  type: "success",
                  timer: 30000
                }); 
                this.selected_brandid = [];
                this.selectbrand_id =[];
                this.selectbrand_name =[];
                this.selectedfrom_date = '';
                this.selectedto_date = '';
                this.segmentId = [];
                this.collectionid = [];
                this.vendornameseach = [];
                this.selectedCatId == ''
                this.sub_catid == []
                this.selected_po_id == []
                this.brandtype == []
                this.sleeveLength == []
                this.includeImages = false;
                this.ReportListing();
                 if(this.user_type == 'Planner_Admin' || this.user_type == 'Planner'){
                  this.getBrandSegmentListForAdmin(this.tempbrandid)
                }
                else{
                  
                  this.getBrandSegmentList();
                }
           
       }
       else
       {
        // alert("no")
        this.$fire({
                  text:"Can not Download",
                  type: "error",
                  timer: 30000
                }); 
        // alert("Can not Download");
        this.selected_brandid = [];
                this.selectbrand_id =[];
                this.selectbrand_name =[];
                this.selectedfrom_date = '';
                this.segmentId= [];
                this.collectionid = [];
                this.vendornameseach = [];
                this.selectedto_date = '';
                this.selectedCatId == ''
                this.sub_catid == []
                this.selected_po_id == []
                this.brandtype == []
                this.sleeveLength == []
                this.includeImages = false;
                this.ReportListing();
                  if(this.user_type == 'Planner_Admin' || this.user_type == 'Planner'){
                  this.getBrandSegmentListForAdmin(this.tempbrandid)
                }
                else{
                  
                  this.getBrandSegmentList();
                }
       }

          })
          .catch(ex => {
            console.log("error-----", ex);
          });
    },

    downloadsheetdeatilscancel: function(){
          this.showdownloadsheetdeatils =!this.showdownloadsheetdeatils;
        },

    downloadHelper(csv) {
    //       // Construct the 'a' element
    //   var link = document.createElement("a");
    //   link.download = "filename";
    //   link.target = "_blank";

    //   // Construct the URI
    //   link.href = url;
    //   document.body.appendChild(link);
    //   link.click();

    //   // Cleanup the DOM
    //   document.body.removeChild(link);
    // // delete link;

      var downloadLink = document.createElement("a");
      var blob = new Blob(["\ufeff", csv]);
      var url = URL.createObjectURL(blob);
      downloadLink.href = url;
      downloadLink.download = "mcc-report.csv";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

    },

    zoomin: function(){
        var myImg = document.getElementById("map");
        var currWidth = myImg.clientWidth;
        if(currWidth >= 2500) return false;
         else{
            myImg.style.width = (currWidth + 100) + "px";
        }
    },
    zoomout: function(){
        var myImg = document.getElementById("map");
        var currWidth = myImg.clientWidth;
        if(currWidth <= 270) return false;
     else{
            myImg.style.width = (currWidth - 100) + "px";
        }
    },
    openimage:function(){
      this.openimagemodel = !this.openimagemodel;
    },
        openimagecancel: function(){
      this.openimagemodel = !this.openimagemodel;
     },
     ReportListing: function ()
    {
      var userData = localStorage.getItem('userData');
    var userInfo = JSON.parse(userData);
    // console.log("@@@@@@@@@@@@@@@@",userInfo)
    // console.log("$$$$$$$$$$$$$$$$$$$$$$$$$")
    // this.access_token = userInfo[0]['token']
      axios.defaults.headers.common['x-access-token'] = userInfo[0]['token'];
      axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
      axios.defaults.headers.common['Accept'] = 'application/json';
      axios.defaults.headers.common['Origin'] = 'http://localhost:8080';

      this.isBusylist = true;

      const Obj = {
        requested_by : userInfo[0].user_id,
        // requested_by: "862",
        request_type :"mcc"
      }

        axios.post(`${CONSTANTS.API_URL}/requestReportListing`, Obj)
        .then(response => {
          console.log("@@@@@@@@@@@@@@@@@@@@",response)
          this.result = response.data;
          this.isBusylist = false;
        
          if ( this.result.returnmsg==="successful") {
            this.report_requestlist = this.result.returnvalue;
            console.log("^^^^^^^^^^^^^^^^^^^^^^^^",this.report_requestlist);
            this.totalrecordlist = this.report_requestlist.length;
            console.log("^^^^^^^^^^^^^^^^^^^^^^^^", this.totalrecordlist);

            // for (let i = 0; i < this.report_requestlist.length; i++) {
            //   var requestlist = this.report_requestlist[i].filters;
            //   this.filerrequestlist.push(requestlist)
            // }
            // console.log("requestlistrequestlistrequestlistrequestlistrequestlistrequestlistrequestlistrequestlistrequestlistrequestlistrequestlistrequestlistrequestlist",this.filerrequestlist)
          } else {
            this.report_requestlist = [];
            this.report_requestlist = 0;
          }
      }).catch(err=>{
        console.log(err)
      })

    },

    getselecteduserbrand: function(cat_id=null){

      var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData);

      this.access_token=userInfo[0]['token']
      axios.defaults.headers.common['x-access-token'] = this.access_token;
      axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
      axios.defaults.headers.common['Accept']= 'application/json';
      axios.defaults.headers.common['Origin']='http://localhost:8080';


      const Obj ={
        user_id: userInfo[0].user_id,
        category_id : cat_id
      }  
      axios.post(`${CONSTANTS.API_URL}/getAllocateddBrandList`,Obj)
      .then(response => {
        this.result = response.data;
        if (this.result.returnmsg === 'Successful') {
          this.brand_item  = this.result.returnvalue;
          console.log("this.brand_item",this.brand_item)
          // this.totalRows = this.result.returnvalue.length;
          for(let j = 0; j < this.brand_item.length; j++) {
                      let WH = {
                  name: this.brand_item[j].brand_title,
                  id: this.brand_item[j].brand_title+ " - " + this.brand_item[j].brand_id,
                }
                // console.log("hjjjjj",WH.name);
                this.brand_itemvalue = [...this.brand_itemvalue, WH];
              }
              // console.log("@@@@@@@@@@@@@@@@@@@@@@@@", this.brand_itemvalue)
        }else {
            this.brand_item =[];
            // this.totalRows=0;
        }
        


      })
      .catch(e => {
        this.errors.push(e)
      })
      },

    formatDate: function(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();
            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            return [year, month, day].join("-");

        },


     /****** Function to Get Brand & Segments ********/
    getBrandSegmentList:function(){
      document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem("userData");
      if (userData) {
        var userInfo = JSON.parse(userData);
        this.user_id = userInfo[0].user_id;
        this.brand_assign = userInfo[0].brand_assign;
        if (userInfo[0].user_type == "Brand_Manager") {
          this.selected_brand_manager = userInfo[0].user_id;
        } else {
          this.selected_brand_manager = userInfo[0].brand_manager;
        }
        var obj = {
          user_id: this.user_id,
          selected_brand: this.brand_assign,
          brand_manager: this.selected_brand_manager,
        };

        axios
          .post(`${CONSTANTS.API_URL}/getBrandSegmentList`, obj)
          .then((response) => {
           
            this.result = response.data;
            if (this.result.returnmsg === "Successful") {
              document.getElementById("overlay").style.display = "none";
              this.segmentarray_list = this.result.returnvalue[0]['segment_list'];
              let tempsegemnt_list =[]
              this.result.returnvalue[0]['segment_list'].map((item, index) => {
                let tempobj ={}
                tempobj.text = item.segment_title
                tempobj.value = item.segment_id
                tempsegemnt_list.push(tempobj)
                // console.log("fffffffffffffffffffff",tempobj)

              })
              // console.log("fffffffffffffffffffff",tempsegemnt_list)

              this.segmentarray_list = tempsegemnt_list

            }
            else{
              this.segmentarray_list = [];
              this.totalRows = 0;
            }
          })
           .catch((e) => {
            this.errors.push(e);
          });

      }
    },

     displayvendorlist:function(brandId){
      console.log('brandId@@@@',brandId);
      // document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem("userData");
      if (userData) {
        var userInfo = JSON.parse(userData);

        const obj = {
          brand_id: [...new Set(brandId)]
        };

        axios
          .post(`${CONSTANTS.API_URL}/getVendorListForReports`, obj)
          .then((response) => {
           document.getElementById("overlay").style.display = "none";
            this.result = response.data;
            if(response.data.returnmsg === "Successful"){
             this.vendorName = response.data.returnvalue
            this.isMultipleVndorSelected = false
             let tempvendor_list =[]
              response.data.returnvalue.map((item, index) => {
                let tempobj ={}
                tempobj.text = item.vendor_name
                tempobj.value = item.vendor_id
                tempvendor_list.push(tempobj)

              })
              this.vendorName = tempvendor_list

              
          }
          })

      }
    },

      // Collection list accorfing to segment selected
      showCollection() {
      // alert()
      if(this.segmentId){
     
      // this.collection_brand_id = brand_id;
      // this.collection_segment_id = segment_id;
      var userdata = localStorage.getItem("userData");
      var brand_id = localStorage.getItem('brand_id');
      var userInfo = JSON.parse(userdata);
      // console.log('userInfo@@@@@@@@@@@@@@',userInfo);

      var user_id = userInfo[0].user_id;
      console.log("this.segmentId", this.segmentId);
      console.log('brand_id',brand_id);
      this.obj_new = {
          brand_id: brand_id,
          segment_id:[],
          user_id: userInfo[0].user_id,
        };

        // Conditionally add segment_id if this.segmentId is set
        if (this.segmentId.length > 0) {
          this.obj_new.segment_id = this.segmentId;
        }
      
      if(userInfo[0].user_type == "Admin"){
        this.obj_new

      }else{
         // document.getElementById("overlay").style.display = "block";
         console.log('brand_id#################',brand_id);
        this.obj_new = {
          brand_id: userInfo[0].brand_assign ? userInfo[0].brand_assign: brand_id,
          segment_id: this.segmentId,
          user_id:  userInfo[0].user_id,
        };
      }
      console.log('this.obj_new',this.obj_new);

      axios
      .post((userInfo[0].user_type == "Admin" || userInfo[0].user_type == "Planner_Admin" || userInfo[0].user_type == "Planner") ? `${CONSTANTS.API_URL}/getSegmentCollectionList`: `${CONSTANTS.API_URL}/getCollectionListOfSegment`,this.obj_new)
      // axios
      //   .post(`${CONSTANTS.API_URL}/getCollectionListOfSegment`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          if (response.data.returnmsg == "Successful") {

            if(userInfo[0].user_type == 'Admin' || userInfo[0].user_type == "Planner_Admin" || userInfo[0].user_type == "Planner"){
                let tempcollction_list =[]
                  response.data.returnvalue.collections.map((item, index) => {
                    let tempobj ={}
                    tempobj.text = item.collection_title
                    tempobj.value = item.collection_title
                    tempcollction_list.push(tempobj)

                  })
                this.collectionData = tempcollction_list
             }
             else{

              this.collectionData = response.data.returnvalue.collections;
              console.log("collections");
              console.log(this.collectionData)
                let tempcollection_list =[]
                response.data.returnvalue.collections.map((item, index) => {
                  let tempobj ={}
                  tempobj.text = item.collection_title
                  tempobj.value = item.collection_id
                  tempcollection_list.push(tempobj)

                })

                this.uniqueData = [...new Set(tempcollection_list)];
                
                this.collectionData = this.uniqueData
                // console.log("this.collectionData ",this.collectionData )

            }
          }else{
            this.collectionData = []
          }
        })
         .catch((e) => {
            this.errors.push(e);
          });
    
      }
     
    },
     callVendorList(brand_id){
      console.log('callVendorList####',brand_id);
        this.isMultipleVndorSelected = true;
        for (let i = 0; i < brand_id.length; i++) {
        var temp =  brand_id[i].split('- ')[1]
        this.tempVendorlist.push(temp)
        }     
        console.log(this.tempVendorlist)
        this.tempbrandid = this.tempVendorlist.toString()
        this.displayvendorlist(this.tempVendorlist);

        if(this.user_type == 'Admin' || this.user_type == 'Planner_Admin' || this.user_type == 'Planner')
        {
            this.getBrandSegmentListForAdmin(this.tempbrandid)
        }
         if(this.user_type == 'Planner_Admin' || this.user_type == 'Planner')
        {
            this.getBrandType(this.tempVendorlist)
        }
        // if(this.user_type == 'Planner_Admin' || this.user_type == 'Planner')
        // {
        //     this.getCategory(this.tempbrandid)
        // }

    },

        /****** Function to Get Brand & Segments ********/
    getBrandSegmentListForAdmin:function(brand_id){
      console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa');
      // document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem("userData");

      if (userData) {
        var userInfo = JSON.parse(userData);
        this.user_id = userInfo[0].user_id;
        
        var obj = {
          brand_id,
        };
       console.log('obj################',obj);
        axios
          .post(`${CONSTANTS.API_URL}/getBrandSegmentListForAdminAndVendor`, obj)
          .then((response) => {
            console.log('response@@@@',response);
           
           this.result = response.data;
           if (this.result.returnmsg === "Successful") {
            //  if(userInfo[0].user_type == 'Admin'){
               this.segmentList_arr = this.result.returnvalue
              //  if(this.user_type == 'Admin'){
                   let tempsegement_list =[]
                   response.data.returnvalue.map((item, index) => {
                     let tempobj ={}
                     tempobj.text = item.segment_title
                     tempobj.value = item.segment_title
                     tempsegement_list.push(tempobj)

                   })
                   this.segmentarray_list = tempsegement_list
              //  }
              //  else{
              //    this.segmentarray_list =this.result.returnvalue
              //  }
              //  this.totalRows = this.result.returnvalue.length
             }
           else{
             this.segmentarray_list = [];
             this.totalRows = 0;
           }
         })
          .catch((e) => {
           this.errors.push(e);
         });

      }
    },
    getBrandType:function(brand_id){
      const obj = {
          brand_id: [...new Set(brand_id)]
        };

     
        axios
          .post(`${CONSTANTS.API_URL}/getBrandTypeData`, obj)
          .then((response) => {
            this.result = response.data;
            if(response.data.returnmsg === "Successful"){
             this.brandTypeName = response.data.returnvalue
            this.isMultipleVndorSelected = false
             let tempbrandtype =[]
              response.data.returnvalue.collections.map((item, index) => {
                let tempobj ={}
                tempobj.text = item.new_brand_type
                tempobj.value = item.new_brand_type
                // tempbrandtype.push(tempobj)
                tempbrandtype = [...tempbrandtype , tempobj]

              })
              this.brandTypeName = tempbrandtype    
          }
          })
    },
    getCategory:function(brand_id){
        var obj = {
          brand_id,
        };
        axios
          .post(`${CONSTANTS.API_URL}/getCategory`, obj)
          .then((response) => {
            this.result = response.data;
            if(response.data.returnmsg === "Successful"){
             this.brandTypeName = response.data.returnvalue
            this.isMultipleVndorSelected = false
             let tempbrandtype =[]
              response.data.returnvalue.collections.map((item, index) => {
                let tempobj ={}
                tempobj.text = item.new_brand_type
                tempobj.value = item.id
                tempbrandtype.push(tempobj)

              })
              this.brandTypeName = tempbrandtype    
          }
          })
    },

    getcategorylistingbybuyer()
    {
      // document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem('userData');
      var brand_id = localStorage.getItem('brand_id');
      var userInfo = JSON.parse(userData)
      const Obj = {
        buyer_id : userInfo[0].user_id,
        brandId: brand_id
          }
          // alert();
          axios.post(`${CONSTANTS.API_URL}/getcategorylistingbybuyer`, Obj)
            .then(response => {
              // document.getElementById("overlay").style.display = "none";
              if (response.data.returnmsg == 'Successful') {
                this.category_name_arr = response.data.returnvalue
              //  console.log(this.category_name_arr,"category_name_arr");
              } else {
                this.category_name_arr = [];
              }

        })

    },

    showDownloadButtion(value)
    {
      // alert(value)
      var userData = localStorage.getItem('userData');
     var userInfo = JSON.parse(userData);
      this.brand_itemvalue = []
      this.selectedCatId= value
      this.selected_brandid = ''
      this.showSubcategory(value,userInfo[0].user_id)

    },

            /******Function To Get Sub Category List********/

      // Sub Category list accorfing to segment selected
      showSubcategory(collection_id,user_id) {
  
          // document.getElementById("overlay").style.display = "block";
          var userData = localStorage.getItem('userData');
          var userInfo = JSON.parse(userData)

          const Obj = {
            collection_id,
            user_id:  user_id ? user_id : userInfo[0].user_id,
          };

          axios
            .post(`${CONSTANTS.API_URL}/getSubcategoryForDashboardFilter`, Obj)
            .then((response) => {
              document.getElementById("overlay").style.display = "none";
              if (response.data.returnmsg == "Successful") {
                this.sub_cat_id_arr = response.data.returnvalue;
                // sub_cattitle
                let tempsubcat_list =[]
                response.data.returnvalue.map((item, index) => {
                  let tempobj ={}
                  tempobj.text = item.sub_cattitle
                  tempobj.value = item.sub_catid
                  // tempsubcat_list.push(tempobj)
                  tempsubcat_list = [...tempsubcat_list, tempobj]

                })
              this.sub_cat_id_arr = tempsubcat_list

              }else{
                this.sub_cat_id_arr = []
              }
            })
            .catch((e) => {
                this.errors.push(e);
              });
                
        },

    /******Function To Get PO Type List********/
    getPoTypeList: function(subcat_id,user_id) {
      this.selected_po_id = null;

      // document.getElementById("overlay").style.display = "block";
       var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData)

      // this.isBusy = true;
      const Obj = {
        subcat_id,
        user_id:  user_id ? user_id : userInfo[0].user_id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getPoTypeList`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;

          if (this.result.returnmsg === "Successful") {
            this.po_typearr = this.result.returnvalue;
            let temppo_list =[]
                response.data.returnvalue.map((item, index) => {
                  let tempobj ={}
                  tempobj.text = item.title
                  tempobj.value = item.po_id
                  // temppo_list.push(tempobj)
                  temppo_list = [...temppo_list, tempobj]
                })
              this.po_typearr = temppo_list
          } else {
            this.po_typearr = [];
            // this.totalRows=0;
            // this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    getSubCatToShowPoType(){
      // alert(this.user_id)
      this.getPoTypeList(this.sub_catid,this.user_id)
    },

    getSleevelength(){
      const Obj ={
        subcat_id : this.sub_catid
      }
      axios.post(`${CONSTANTS.API_URL}/getFabricTypeList`,Obj)
           .then(response => {
             this.result = response.data;
             if (this.result.returnmsg === 'Successful') {
              this.sleeveLength_arr = this.result.returnvalue[0].SleeveLength;
              console.log("befoe",  this.sleeveLength_arr);
              let tempsleeveslist =[]
                  this.result.returnvalue[0].SleeveLength.map((item, index) => {
                    let tempobj ={}
                    tempobj.text = item.title
                    tempobj.value = item.title
                
                    tempsleeveslist = [...tempsleeveslist, tempobj]
                  })
                this.sleeveLength_arr = tempsleeveslist
                console.log("after",  this.sleeveLength_arr);
             }
             else{
              this.sleeveLength_arr=[]
             }
           })
    }


  }
}
</script>
<style>
button.close {
  display: none;
}

#overlaymcclist {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 9999; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loadermcclist {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 50px;
  height: 50px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
} 
</style>
